import {Address} from "address-rfc2821";

/**
 * Validates a single email address string.
 *
 * @param address {string} The email address to validate
 * @returns {boolean} true if the string was a valid email address, false if not
 */
export function validateSingleEmailAddress(address: string | null | undefined): boolean {
    if (!address || address.trim().length === 0) {
        return false;
    }
    try {
        const a = new Address(address);
        return !!a.user;
    } catch (_error) { // NOSONAR(S2486)
        // Do not log to console as it logs on every keystroke while entering
        // an email address, and test validation fails as the errors confuse
        // the code we have for checking for JavaScript errors.
        return false;
    }
}
